
export const emailVerificationLinkExpireMsg = "Your email verification link has expired.";
export const recruiterRegistrationLinkExpireMsg = "Your recruiter registration link has expired.";
export const recruiterContractSignInLinkExpireMsg = "The link to sign your recruiter contract has expired. You have already signed contract document successfully.";